import { DisplayHeading } from "../ui/display-heading";
import { SampleReviewsNote } from "./sample-reviews-note";

/** The bold Reviews header: the heading, an optional line under it, and the sample-reviews note. */
interface BoldReviewsHeaderProps {
  heading: string;
  subheading?: string;
  /** Whether the section is showing sample reviews. */
  showSampleNote: boolean;
}

/**
 * The bold Reviews header: the heading in display capitals, set left like the
 * page's other bold sections.
 * @param {BoldReviewsHeaderProps} props The header.
 * @returns {React.JSX.Element} The header.
 */
const BoldReviewsHeader = ({ heading, subheading, showSampleNote }: BoldReviewsHeaderProps): React.JSX.Element => (
  <div className="jobsite:mb-10 jobsite:md:mb-12">
    <DisplayHeading heading={heading} subheading={subheading} className="jobsite:mb-0 jobsite:md:mb-0" />
    {showSampleNote && <SampleReviewsNote />}
  </div>
);

export { BoldReviewsHeader };
